<template>
  <v-component
    :is="article.state == 'attachment' ? 'a' : 'div'"
    @click="openDialog"
    @keyup.enter="openDialog"
    class="article"
    :class="{
      posted: article.posted,
      'no-link-yet': article.state == 'external_link' && !article.content_link
    }"
    :href="article.state == 'attachment' ? article.attachment_url : false"
    :download="article.state == 'attachment' ? article.title : false"
    role="button"
    tabindex="0"
  >
    <SliderModal
      :prevId="prevId"
      :nextId="nextId"
      :id="article.id"
      name="article"
      v-model="dialog"
    >
      <ArticleContent :article="article" />
    </SliderModal>
    <v-responsive
      class="article-preview"
      :class="{
        'article-video_reference':
          !article.hide_title &&
          (article.state == 'video_reference' ||
            article.vimeo_id ||
            article.youtube_id)
      }"
      :style="styles"
      :aspect-ratio="285 / 160"
    >
    </v-responsive>
    <div v-if="!article.hide_title" class="article-title">
      {{ article.title }}
    </div>
  </v-component>
</template>

<script>
import ArticleContent from "./ArticleContent";
import placeholder from "@/assets/article-placeholder.png";

export default {
  name: "Article",
  components: { ArticleContent },
  props: {
    article: Object,
    prevId: Number,
    nextId: Number
  },
  data() {
    return {
      dialog: false
    };
  },
  mounted() {
    const { article_id } = this.$route.query;

    if (article_id == this.article.id) {
      this.openDialog();
    }
  },
  methods: {
    openDialog() {
      if (this.article.posted) {
        this.$gtag.event("Article", {
          event_category: "article_click",
          event_label: "Article",
          title: this.article.title,
          article_id: this.article.id
        });
        if (this.article.state == "attachment") {
          return;
        } else if (this.article.state == "video_reference") {
          this.$root.$emit("setActiveEvent", {
            id: this.article.id,
            type: "article",
            title: this.article.title,
            start_at: this.article.posted_at,
            vimeo_id: this.article.vimeo_id,
            youtube_id: this.article.youtube_id,
            filtered_slides: this.article.slides.length
              ? [...this.article.slides]
              : [
                  {
                    id: 0,
                    preview_urls: this.article.preview_urls
                  }
                ]
          });
          window.scrollTo(0, 0);
        } else if (this.article.state == "external_link") {
          if (this.article.content_link)
            window.open(this.article.content_link, "_blank");
        } else {
          this.dialog = true;
        }
      }
    }
  },
  computed: {
    styles() {
      const preview = this.article.preview_urls?.thumb || placeholder;

      return {
        backgroundImage: `url(${preview})`
      };
    }
  }
};
</script>

<style scoped lang="scss">
.article {
  display: block;
  text-decoration: none;
  cursor: default;

  &.posted:not(.no-link-yet) {
    cursor: pointer;

    &:hover {
      filter: brightness(103%);
    }
  }
}

.article-preview {
  background-color: #e7e7e7;
  background-size: cover;
  background-position: center center;
  position: relative;
  &.article-video_reference::before {
    content: "";
    display: block;
    position: absolute;
    width: 15.44%;
    padding-bottom: 15.44%;
    background-size: 72.73%;
    background-position: center;
    background-image: url(~@/assets/play.svg);
    top: 0;
    left: 0;
  }
}

.article-title {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin: 10px 0px;
  color: #1874dc;
}

.no-link-yet {
  cursor: default;
}
</style>
